import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel } from 'swiper/modules';
import { useTeamColors } from 'hooks';
import { PrevArrowIcon, NextArrowIcon } from 'assets/icons';

import {
  ErrorMessage,
  GameInfoButton,
  Teams,
  TvChannel,
  GameResult,
} from 'components';
import GameDate from 'components/GameDate';
import { CurrentGameButton } from './components/CurrentGameButton';

import 'swiper/swiper-bundle.css';
import {
  StyledSection,
  LeftSideBar,
  RightSideBar,
  SlideContent,
  ArrowWrapper,
} from './style';

export const DashboardChampionship = ({ games, currentGame }) => {
  const { mainColor } = useTeamColors();
  // eslint-disable-next-line no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams({
    game: currentGame,
  });
  const leagueFromUrl = searchParams.get('league');

  //** FIND event_id FUNCTION */
  const slideChanged = useCallback(
    (index) => {
      if (!games.length) return;
      const oneGame = games[index]?.event_id;
      if (oneGame) {
        setSearchParams(
          (prevValue) => {
            prevValue.set('eventId', oneGame);
            return prevValue;
          },
          { replace: true }
        );
      }
    },
    [games, setSearchParams]
  );

  if (!games.length) {
    return (
      <StyledSection>
        <ErrorMessage title="Unable to display events. Please make another selection or try again later." />
      </StyledSection>
    );
  }

  return (
    <>
      <LeftSideBar>
        <ArrowWrapper className="swiper-button-prev-unique">
          <PrevArrowIcon fill={mainColor} />
        </ArrowWrapper>
      </LeftSideBar>
      <StyledSection>
        <Swiper
          grabCursor={true}
          id="main-slider"
          initialSlide={currentGame}
          modules={[Navigation, Mousewheel]}
          mousewheel={true}
          navigation={{
            prevEl: '.swiper-button-prev-unique',
            nextEl: '.swiper-button-next-unique',
          }}
          onSlideChange={(swiper) => {
            slideChanged(swiper.activeIndex);
          }}
          slidesPerView={1}
          tag="section"
          wrapperTag="ul"
        >
          {games?.map((game) => (
            <SwiperSlide key={game.event_id} tag="li">
              <SlideContent>
                <Teams team={game.event_text} />
                <GameInfoButton
                  city={game.location_city}
                  date={game.event_start}
                  eventLeagueName={game.event_league_name || leagueFromUrl}
                  locationId={game.event_location_id}
                  opponent={game.event_text}
                  region={game.stadium_country}
                  stadium={game.stadium_name}
                  stadiumAddress={game.stadium_address}
                  stadiumLocation={{
                    lat: game?.stadium_lat,
                    lng: game?.stadium_lng,
                  }}
                  timeZone={game.stadium_time_zone}
                  zipCode={game.stadium_zip_code}
                  channel={game.event_tv_channel}
                  eventState={game.event_state}
                  headline={game.event_notes_headline}
                />
                <GameDate
                  endDate={game.event_end}
                  eventState={game.event_state}
                  eventTime={game.event_start}
                  isChampionship
                />
                <TvChannel channel={game.event_tv_channel} />
                <GameResult
                  date={game.event_start}
                  endDate={game.event_end}
                  result={game.event_outcome}
                />
                <CurrentGameButton isChampionship />
              </SlideContent>
            </SwiperSlide>
          ))}
        </Swiper>
      </StyledSection>
      <RightSideBar>
        <ArrowWrapper className="swiper-button-next-unique">
          <NextArrowIcon fill={mainColor} />
        </ArrowWrapper>
      </RightSideBar>{' '}
    </>
  );
};
